"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PalletLabelDownloader = void 0;
exports.PalletLabelDownloader = {
    MERCHANT: 'MERCHANT',
    CROSSDOCK: 'CROSSDOCK',
    HUB: 'HUB'
};
//# sourceMappingURL=pallet-label-downloader.js.map